import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const BriefcaseIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon className='briefcase-icon' {...props} viewBox={'0 0 26 24'}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="-45 141 512 512">
                <path strokeWidth="15px" d="M420.333,247.667H313.667v-21.333c0-23.531-19.135-42.667-42.667-42.667H143
                    c-23.531,0-42.667,19.135-42.667,42.667v21.333H-6.333c-23.531,0-42.667,19.135-42.667,42.667v277.333
                    c0,23.531,19.135,42.667,42.667,42.667h426.667c23.531,0,42.667-19.135,42.667-42.667V290.333
                    C463,266.802,443.865,247.667,420.333,247.667z M121.667,226.333c0-11.76,9.573-21.333,21.333-21.333h128
                    c11.76,0,21.333,9.573,21.333,21.333v21.333H121.667V226.333z M420.333,589H-6.333c-11.76,0-21.333-9.573-21.333-21.333V412.4
                    c6.301,3.674,13.527,5.934,21.333,5.934h170.667v32c0,5.896,4.771,10.667,10.667,10.667h64c5.896,0,10.667-4.771,10.667-10.667v-32
                    h170.667c7.806,0,15.033-2.259,21.333-5.934v155.267C441.667,579.427,432.094,589,420.333,589z M185.667,439.667V397h42.667v42.667
                    H185.667z M420.333,397H249.667v-10.667c0-5.896-4.771-10.667-10.667-10.667h-64c-5.896,0-10.667,4.771-10.667,10.667V397H-6.333
                    c-11.76,0-21.333-9.573-21.333-21.333v-85.333c0-11.76,9.573-21.333,21.333-21.333h426.667c11.76,0,21.333,9.573,21.333,21.333
                    v85.333C441.667,387.427,432.094,397,420.333,397z"/>
            </svg>
        </SvgIcon>
    )
};

export default BriefcaseIcon;
